// extracted by mini-css-extract-plugin
export default {"col":"Grid_col__LAbt9","collapse":"Grid_collapse__9nW1V"};